export const Unapproved = 0;
export const Approved = 1;
export const PostApproved = 2;